/**
 * Configuración de Whitelist (Lista Blanca) para Auto-Registro de Usuarios en la Mesa de Servicio.
 * 
 * Lee las variables de entorno definidas en el archivo .env:
 * - VITE_ALLOWED_DOMAINS: Dominios autorizados separados por coma (ej. "bidgroup.com,bidtecnologia.mx")
 * - VITE_ALLOWED_EMAILS: Correos individuales permitidos separados por coma (ej. "externo@proveedor.com")
 */

/**
 * Obtiene los dominios autorizados desde las variables de entorno (.env)
 */
export function getAllowedDomainsFromEnv(): string[] {
  const envVal = import.meta.env.VITE_ALLOWED_DOMAINS || "";
  if (!envVal.trim()) {
    // Dominios por defecto si no se han especificado en el .env
    return [
      "bidgroup.com",
      "bidagua.mx",
      "bidcapital.mx",
      "biddeportes.mx",
      "bidenergy.mx",
      "bidg.com",
      "bidg.mx",
      "bidnomina.mx",
      "bidprosper.com",
      "bidtecnologia.mx",
      "empowermedia.mx",
      "grupotresr.com.mx",
      "ifd.com.mx",
      "kwantreats.mx",
    ];
  }
  return envVal
    .split(",")
    .map((d: string) => d.trim().toLowerCase())
    .filter(Boolean);
}

/**
 * Obtiene los correos individuales autorizados desde las variables de entorno (.env)
 */
export function getAllowedEmailsFromEnv(): string[] {
  const envVal = import.meta.env.VITE_ALLOWED_EMAILS || "";
  if (!envVal.trim()) return [];
  return envVal
    .split(",")
    .map((e: string) => e.trim().toLowerCase())
    .filter(Boolean);
}

/**
 * Valida si un correo electrónico cumple con la Whitelist configurada en el .env.
 * Devuelve true si el dominio o el correo exacto está autorizado.
 */
export function isEmailWhitelisted(email: string): boolean {
  if (!email || typeof email !== "string") return false;
  const normalizedEmail = email.trim().toLowerCase();

  // 1. Verificar si el correo exacto está en VITE_ALLOWED_EMAILS
  const allowedEmails = getAllowedEmailsFromEnv();
  if (allowedEmails.includes(normalizedEmail)) {
    return true;
  }

  // 2. Extraer el dominio del correo y verificar si está en VITE_ALLOWED_DOMAINS
  const domainParts = normalizedEmail.split("@");
  if (domainParts.length !== 2) return false;

  const domain = domainParts[1].trim().toLowerCase();
  const allowedDomains = getAllowedDomainsFromEnv();
  return allowedDomains.includes(domain);
}
